exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-page-template-jsx": () => import("./../../../src/templates/pageTemplate.jsx" /* webpackChunkName: "component---src-templates-page-template-jsx" */),
  "component---src-templates-service-page-template-jsx": () => import("./../../../src/templates/servicePageTemplate.jsx" /* webpackChunkName: "component---src-templates-service-page-template-jsx" */)
}

